import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I are officially kind of smart",
  "description": "",
  "published": "2008-11-19T00:00:00.000Z",
  "redirect_from": ["/blog/i-are-officially-kind-of-smart/swizec/41"],
  "categories": "food for thought, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Some of you might remember my taking a `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/took-iq-test-found-problem/2/388"
      }}>{`Mensa approved IQ test`}</a>{` about a week ago, well today, finally, results came in and what I found out was surprisingiy similar to what I'd already known. My IQ seems to be 134, which is supposedly in the top 6% of the human population - not perfect, but good enough I say, I've got objective proof that I'm smart rather than stupid as I so often feel I am.`}</p>
    <p>{`But how on earth did I know I'd get about that result? Online IQ tests to be honest, for some reason I've been nearly obsessed with knowing my IQ for the past few years and have thus solved many online tests. Some better, some worse. The results, accordingly, varied quite a lot, but a clear median shined out from the masses and that was 130-ish.`}</p>
    <p>{`See, I knew enough not to trust the tests that want to sell me their results, the whole point of those is giving a high score so you'd be tempted to buy the advanced results. I also knew not to trust the tests that asked for too much knowledge because hey, how am I supposed to know what a friggin' nickel or dime is?`}</p>
    <p>{`Lately, however, I've solved `}<a parentName="p" {...{
        "href": "http://apps.facebook.com/advancediqtest/"
      }}>{`the facebook IQ test`}</a>{` and found it to be the most accurate of them all and it in fact showed a result quite similar to that of Mensa's test. Facebook says my IQ is 143 and given the fact that performance can vary between days, that I took the facebook test in my natural environment, nighttime, and some other factors, I'd say it's a rather accurate way of gleaning one's IQ.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      